import { UNIVERSAL_AI_ENDPOINTS } from "./universal-ai"
import { CENTERAL_ERROR_CAPTURE_ENDPOINTS } from "./error-capture"
import { CP_DETECT_ENDPOINTS } from "./cp-detect"
import { AUTOMATION_ENDPOINTS } from "./automation"
import { CALL_STATS_ENDPOINTS } from "./call-stats"

export const API_ENDPOINTS = {
  cp_detect: CP_DETECT_ENDPOINTS,
  error_capture: CENTERAL_ERROR_CAPTURE_ENDPOINTS,
  automation: AUTOMATION_ENDPOINTS,
  universal_ai: UNIVERSAL_AI_ENDPOINTS,
  call_stats: CALL_STATS_ENDPOINTS,
}